import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

const spaceSeparator = ' '
const endOfLineDot = '. '

const CookieBannerMobileContent = () => {
    const intl = useIntl()

    return (
        <>
            <FormattedMessage id="header.cookieMobileContent.part1" />
            {spaceSeparator}
            <a
                href={`${intl.formatMessage({
                    id: 'footer.privacy.link',
                })}#5-cookies`}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
            >
                <FormattedMessage id="header.cookieMobileLink" />
            </a>

            {endOfLineDot}
            <FormattedMessage id="header.cookieMobileContent.part2" />
        </>
    )
}

export default CookieBannerMobileContent
